module.exports = __webpack_public_path__ + "media/images/countrysquared/ch-1928ff1dcfe30da8d725b9f9fb97cb2b.svg";